module.exports = __webpack_public_path__ + "static/media/montage-tests.5b74d768.gif";